module.exports = __webpack_public_path__ + "img/step11.705d73c0.png";